var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Input',_vm._g(_vm._b({attrs:{"type":"number"},on:{"on-keyup":_vm.btKeyUp},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}},'Input',_vm.$attrs,false),_vm.$listeners),[(_vm.unit)?_c('span',{staticClass:"unit",attrs:{"slot":"suffix"},slot:"suffix"},[_vm._v(_vm._s(_vm.unit))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }